/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Pose_UnavailableInputs */

const en_us2_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The automatic pose check didn't load. The photo is taken when the countdown ends.`)
};

const pt_br2_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A conferência automática da pose não carregou. A foto sai no fim da contagem.`)
};

const es_419_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La revisión automática de la pose no cargó. La foto se toma al terminar la cuenta regresiva.`)
};

const pt_pt2_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A verificação automática da pose não carregou. A foto é tirada no fim da contagem.`)
};

const fr_fr2_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vérification automatique de la pose n'a pas chargé. La photo sera prise à la fin du compte à rebours.`)
};

const de_de2_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Posenprüfung wurde nicht geladen. Das Foto wird am Ende des Countdowns gemacht.`)
};

const it_it2_body_assessment_pose_unavailable = /** @type {(inputs: Body_Assessment_Pose_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il controllo automatico della posa non si è caricato. La foto viene scattata alla fine del conto alla rovescia.`)
};

/**
* | output |
* | --- |
* | "The automatic pose check didn't load. The photo is taken when the countdown ends." |
*
* @param {Body_Assessment_Pose_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_pose_unavailable = /** @type {((inputs?: Body_Assessment_Pose_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Pose_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_pose_unavailable(inputs)
	if (locale === "es-419") return es_419_body_assessment_pose_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_pose_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_pose_unavailable(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_pose_unavailable(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_pose_unavailable(inputs)
	return en_us2_body_assessment_pose_unavailable(inputs)
});
export { body_assessment_pose_unavailable as "body-assessment.pose_unavailable" }